import React from "react"

const Feature = ({ icon, headline, description }) => {
  return (
    <div className="flex flex-col gap-4 items-center text-center w-full md:w-1/3">
      <div className="p-3 rounded-lg bg-black">
        <div className="text-green-500">{icon}</div>
      </div>
      <h3 className="text-xl font-semibold">{headline}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  )
}

export default Feature

